import React, { useEffect, useRef, useImperativeHandle } from 'react';
import $ from 'jquery';

// Trumbowyg's core and plugins look for jQuery on window when they load, so jquery-global is imported first.
import '../jquery-global';
import 'trumbowyg';
import 'trumbowyg/dist/plugins/fontfamily/trumbowyg.fontfamily.min.js';
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js';
import 'trumbowyg/dist/ui/trumbowyg.min.css';
import trumbowyg_icons_url from 'trumbowyg/dist/ui/icons.svg';

const c_TrumbowygButtons = [
	['formatting'],
	['fontfamily', 'fontsize'],
	['strong', 'em'],
	['unorderedList', 'orderedList'],
	['link'],
	['removeformat'],
];

// A Trumbowyg rich text editor holding initial_value. The parent reads the edited HTML through the ref's get_html.
const TrumbowygEditor = React.forwardRef(function TrumbowygEditor({initial_value}, ref){
	const wrapper_ref = useRef(null);
	const editor_ref = useRef(null);

	useImperativeHandle(ref, ()=>{
		return {
			get_html: ()=>{
				return $(editor_ref.current).trumbowyg('html');
			}
		};
	});

	// The editor is built once, on its own element inside the wrapper, and destroyed when the component goes, so
	// React never renders over the markup Trumbowyg adds.
	useEffect(()=>{
		const wrapper = wrapper_ref.current;
		const editor_element = document.createElement('div');
		wrapper.appendChild(editor_element);
		editor_ref.current = editor_element;

		$(editor_element).trumbowyg({
			btns: c_TrumbowygButtons,
			autogrow: true,
			svgPath: trumbowyg_icons_url
		});

		if(initial_value){
			$(editor_element).trumbowyg('html', initial_value);
		}

		return ()=>{
			$(editor_element).trumbowyg('destroy');
			wrapper.innerHTML = '';
		};
	}, []);

	return (
		<div ref={wrapper_ref}></div>
	);
});

export default TrumbowygEditor;
